module.exports = __webpack_public_path__ + "img/logomem.e5eae428.jpg";